import { render } from "./GrupoDescCreate.vue?vue&type=template&id=646d46dd&scoped=true"
import script from "./GrupoDescCreate.vue?vue&type=script&lang=js"
export * from "./GrupoDescCreate.vue?vue&type=script&lang=js"

import "./GrupoDescCreate.vue?vue&type=style&index=0&id=646d46dd&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646d46dd"]])

export default __exports__